<script setup lang="ts">
import {DataTable} from 'primevue';
import {useSlots} from 'vue';

const slots = useSlots();
</script>

<template>
<DataTable v-bind="$attrs" stripedRows>
    <template v-for="(_, slotName) in slots" :key="slotName" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps || {}" />
    </template>
    <template #loading>
        <aeg-loader message="" />
    </template>
</DataTable>
</template>

<style scoped lang="scss">

</style>
